import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class RouterService {
  public showGuide: Observable<boolean>;
  public showGuideSubject: BehaviorSubject<boolean>;
  constructor(private router: Router) {
    this.showGuideSubject = new BehaviorSubject<boolean>(false);
    this.showGuide = this.showGuideSubject.asObservable();
  }
  public GetURI() {
    return this.router.url;
  }

  setShowGuide(show: boolean) {
    this.showGuideSubject.next(show);
}
}



// WEBPACK FOOTER //
// ./src/app/service/RouterService.ts